(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["subscription-cart-benefits"] && !Shopify.designMode) return;
  try {
    class PetesSubscriptionBenefits extends HTMLElement {
    connectedCallback() {
      /* Cart section refreshes can clone this element's serialized markup,
         including data-ready. Use an instance-only guard so the clone still
         initializes and can remove stale managed benefits. */
      if (this._petesReady) return
      this._petesReady = true
      this.dataset.ready = 'true'
      this.variantIds = {
        protection: Number(this.dataset.protectionVariant),
        recipeBook: Number(this.dataset.recipeBookVariant),
        mysteryGift: Number(this.dataset.mysteryGiftVariant),
      }
      this.labels = JSON.parse(this.querySelector('[data-petes-benefit-labels]').textContent)
      this.protectionPlanIds = JSON.parse(this.querySelector('[data-petes-protection-plans]').textContent).map(String)
      this.syncing = false
      this.syncTimer = null
      this.cart = null
      this.tier = Number(this.dataset.initialTier) || 0
      this.initialVisibleCount = Number(this.dataset.initialVisibleCount) || 0
      this.qualifyingPlanId = ''

      if (!window.__petesSubscriptionBenefitsFetchPatched) {
        window.__petesSubscriptionBenefitsFetchPatched = true
        const originalFetch = window.fetch.bind(window)
        window.fetch = async (...args) => {
          const response = await originalFetch(...args)
          const request = args[0]
          const url = typeof request === 'string' ? request : request && request.url
          if (url && /\/cart\/(add|change|update|clear)\.js/.test(url)) {
            window.dispatchEvent(new CustomEvent('petes:cart-mutated'))
          }
          return response
        }
      }

      window.addEventListener('petes:cart-mutated', () => this.scheduleSync())
      this.handleProductSubmit = (event) => this.primeTierFromSubmit(event)
      document.addEventListener('submit', this.handleProductSubmit, true)
      document.addEventListener('toggle-cart', () => {
        this.render()
        this.scheduleSync()
        ;[120, 500, 1000].forEach((delay) => window.setTimeout(() => this.render(), delay))
      })
      this.observer = new MutationObserver(() => this.render())
      this.observer.observe(document.body, { childList: true, subtree: true })
      this.render()
      this.scheduleSync()
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect()
      if (this.syncTimer) window.clearTimeout(this.syncTimer)
      if (this.handleProductSubmit) document.removeEventListener('submit', this.handleProductSubmit, true)
    }

    scheduleSync() {
      if (this.syncing) return
      window.clearTimeout(this.syncTimer)
      this.syncTimer = window.setTimeout(() => this.sync(), 0)
    }

    tierFromPackSource(source) {
      const match = String(source || '').match(/(?:^|\D)(12|8|6|4|3)(?:\D|$)/)
      const packSize = match ? Number(match[1]) : 0
      return packSize >= 12 ? 12 : packSize >= 6 ? 6 : packSize >= 3 ? 3 : 0
    }

    primeTierFromSubmit(event) {
      const form = event.target
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-simple-form]')) return
      const root = form.closest('[data-simple-pdp]')
      if (!root) return
      const purchaseType = root.querySelector('input[name^="purchaseType-"]:checked')
      if (!purchaseType || purchaseType.value !== 'purchaseTypeSubscription') return
      const selectedPack = root.querySelector('[data-simple-option-group] input:checked')
      const tier = this.tierFromPackSource(selectedPack ? selectedPack.value : '')
      if (!tier) return
      this.tier = tier
      this.render()
    }

    async request(url, options) {
      const response = await fetch(url, options)
      if (!response.ok) throw new Error('Cart benefit sync failed')
      return response.json()
    }

    managedBenefit(item) {
      return item.properties && item.properties._petes_subscription_benefit
    }

    bundleComponent(item) {
      const properties = item.properties || {}
      return Boolean(properties._bundle) && properties._bundle_main !== 'true' && properties._bundle_main !== true
    }

    itemPackSize(item) {
      if (!item.selling_plan_allocation || this.managedBenefit(item)) return 0
      if (this.bundleComponent(item)) return 0
      const properties = item.properties || {}
      const source = [properties._omg_bundle_size, item.variant_title, item.product_title].filter(Boolean).join(' ')
      const match = source.match(/(?:^|\D)(12|8|6|4|3)(?:\D|$)/)
      return match ? Number(match[1]) : 0
    }

    qualifyingCart(cart) {
      let packSize = 0
      let planId = ''
      cart.items.forEach((item) => {
        const size = this.itemPackSize(item)
        if (size >= packSize) {
          packSize = size
          planId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
            ? String(item.selling_plan_allocation.selling_plan.id)
            : ''
        }
      })
      return {
        tier: packSize >= 12 ? 12 : packSize >= 6 ? 6 : packSize >= 3 ? 3 : 0,
        planId,
      }
    }

    desiredBenefits(tier, planId) {
      if (!tier) return []
      const protection = {
        name: 'order-protection',
        id: this.variantIds.protection,
        sellingPlan: this.protectionPlanIds.includes(String(planId)) ? Number(planId) : null,
      }
      const benefits = [
        protection,
        { name: 'recipe-book', id: this.variantIds.recipeBook, sellingPlan: null },
      ]
      if (tier >= 12) {
        benefits.push({ name: 'mystery-gift', id: this.variantIds.mysteryGift, sellingPlan: null })
      }
      return benefits.filter((benefit) => benefit.id)
    }

    cartAttributes(tier) {
      return {
        petes_subscription_tier: tier ? String(tier) : '',
        petes_welcome_kit: tier ? 'eligible' : '',
        petes_raffle_eligible: tier >= 6 ? 'true' : '',
        petes_gift_card_eligible: tier >= 6 ? 'true' : '',
        petes_mystery_gift: tier >= 12 ? 'true' : '',
        petes_order_protection: tier ? 'true' : '',
      }
    }

    async sync() {
      if (this.syncing) return
      this.syncing = true
      try {
        let cart = await this.request('/cart.js', { headers: { Accept: 'application/json' } })
        const qualifying = this.qualifyingCart(cart)
        this.cart = cart
        this.tier = qualifying.tier
        this.qualifyingPlanId = qualifying.planId
        this.render()
        const desired = this.desiredBenefits(qualifying.tier, qualifying.planId)
        const desiredByName = new Map(desired.map((benefit) => [benefit.name, benefit]))
        const updates = {}
        const found = new Set()

        cart.items.forEach((item) => {
          const name = this.managedBenefit(item)
          if (!name) return
          const wanted = desiredByName.get(name)
          const actualPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
            ? String(item.selling_plan_allocation.selling_plan.id)
            : ''
          const wantedPlan = wanted && wanted.sellingPlan ? String(wanted.sellingPlan) : ''
          const wrongVariant = wanted && Number(item.variant_id) !== Number(wanted.id)
          if (!wanted || found.has(name) || actualPlan !== wantedPlan || wrongVariant) {
            updates[item.key] = 0
          } else {
            found.add(name)
          }
        })

        const attributes = this.cartAttributes(qualifying.tier)
        const attributesChanged = Object.entries(attributes).some(([key, value]) => {
          return String(cart.attributes[key] || '') !== value
        })
        let cartChanged = false
        if (Object.keys(updates).length || attributesChanged) {
          await this.request('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates, attributes }),
          })
          cartChanged = true
        }

        const missing = desired.filter((benefit) => !found.has(benefit.name))
        if (missing.length) {
          const items = missing.map((benefit) => {
            const item = {
              id: benefit.id,
              quantity: 1,
              properties: {
                _petes_subscription_benefit: benefit.name,
                _petes_subscription_tier: String(qualifying.tier),
              },
            }
            if (benefit.sellingPlan) item.selling_plan = benefit.sellingPlan
            return item
          })
          await this.request('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          })
          cartChanged = true
        }

        if (cartChanged) cart = await this.request('/cart.js', { headers: { Accept: 'application/json' } })
        this.cart = cart
        this.tier = qualifying.tier
        this.qualifyingPlanId = qualifying.planId
        if (cartChanged && window.location.pathname === '/cart') {
          window.location.reload()
          return
        }
        const drawerIsOpen = Boolean(document.querySelector('#cart-drawer [role="dialog"]'))
        if (drawerIsOpen && cartChanged && typeof window.updateCart === 'function') window.updateCart()
        ;[180, 600, 1200].forEach((delay) => window.setTimeout(() => this.render(), delay))
      } catch (error) {
        console.error(error)
      } finally {
        this.syncing = false
      }
    }

    benefitLabels() {
      if (!this.tier) return []
      const labels = [this.labels.freeShipping, this.labels.orderProtection, this.labels.recipeBook]
      if (this.tier >= 6) labels.push(this.labels.raffle, this.labels.giftCard)
      if (this.tier >= 12) labels.push(this.labels.mysteryGift)
      return labels
    }

    hideManagedRows(root) {
      const handles = ['petes-order-protection', 'digital-product', 'mystery-gift', 'bundle-component-gnocchi-pro']
      handles.forEach((handle) => {
        root.querySelectorAll(`a[href*="/products/${handle}"]`).forEach((link) => {
          const row = link.closest('li') || link.closest('[data-cart-item]')
          if (row && !row.hidden) row.hidden = true
        })
      })
    }

    ownText(element) {
      return Array.from(element.childNodes)
        .filter((node) => node.nodeType === Node.TEXT_NODE)
        .map((node) => node.textContent)
        .join(' ')
        .trim()
    }

    syncVisibleItemCount(drawer) {
      const visibleCount = this.cart
        ? this.cart.items
          .filter((item) => !this.managedBenefit(item) && !this.bundleComponent(item))
          .reduce((total, item) => total + item.quantity, 0)
        : this.initialVisibleCount
      drawer.querySelectorAll('div, p, span').forEach((element) => {
        if (!/^\d+\s+items?$/i.test(this.ownText(element))) return
        const label = `${visibleCount} ${visibleCount === 1 ? 'item' : 'items'}`
        if (element.textContent.trim() !== label) element.textContent = label
      })
    }

    syncBundleTitles(drawer) {
      drawer.querySelectorAll('a[href*="/products/bundle-builder-"]').forEach((link) => {
        const match = (link.getAttribute('href') || '').match(/\/products\/bundle-builder-(\d+)-pack/i)
        const title = link.querySelector('span.block.font-bold.uppercase')
        if (!match || !title) return
        const label = this.labels.mixAndMatchTitle.replace('__PACK__', match[1])
        if (title.textContent.trim() !== label) title.textContent = label
      })
    }

    syncShippingMessage(drawer) {
      const managedBlocks = drawer.querySelectorAll('[data-petes-subscription-shipping-banner]')
      if (!this.tier) {
        managedBlocks.forEach((block) => {
          block.style.removeProperty('display')
          delete block.dataset.petesSubscriptionShippingBanner
        })
        return
      }

      const candidates = Array.from(drawer.querySelectorAll('div, p, span')).filter((element) => {
        return /(away from free shipping|congratulations! you have free shipping)/i.test(element.textContent || '')
      })
      const message = candidates.sort((a, b) => a.textContent.length - b.textContent.length)[0]
      if (message) {
        const shippingBlock = message.closest('.border-b-4') || message.parentElement
        if (shippingBlock) {
          shippingBlock.dataset.petesSubscriptionShippingBanner = 'true'
          shippingBlock.style.setProperty('display', 'none', 'important')
        }
      }
    }

    hideUpsells(drawer) {
      drawer.querySelectorAll('[data-cluster-upsell]').forEach((block) => block.remove())

      const headings = Array.from(drawer.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong, span')).filter((element) => {
        return /^(goes great with your order|you may like):?$/i.test(this.ownText(element))
      })
      headings.forEach((heading) => {
        const parent = heading.parentElement
        const region = parent && parent.querySelector('[role="region"]')
        if (parent && region) parent.hidden = true
        else {
          heading.hidden = true
          if (region) region.hidden = true
        }
      })
    }

    deepQueryAll(root, selector) {
      const matches = Array.from(root.querySelectorAll(selector))
      root.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot) matches.push(...this.deepQueryAll(element.shadowRoot, selector))
      })
      return matches
    }

    syncProtectionCheckout(drawer) {
      const buttons = this.deepQueryAll(drawer, 'button')
      const paidProtectionButton = buttons.find((button) => /^CHECKOUT\+/i.test(button.textContent.trim()))
      const nativeCheckoutButton = buttons.find((button) => /^CHECKOUT$/i.test(button.textContent.trim()))
      const withoutProtectionButton = this.deepQueryAll(drawer, '.sb__non-covered-link')[0] || buttons.find((button) => /CONTINUE WITHOUT PROTECTION/i.test(button.textContent.trim()))
      const protectionBlock = this.deepQueryAll(drawer, '.sb__parent')[0]
      const widgetElement = protectionBlock || withoutProtectionButton || paidProtectionButton
      const widgetRoot = widgetElement ? widgetElement.getRootNode() : null
      const widgetHost = widgetRoot && widgetRoot.host ? widgetRoot.host : protectionBlock
      drawer.classList.toggle('petes-subscription-cart', Boolean(this.tier))

      if (this.tier) {
        if (paidProtectionButton) paidProtectionButton.hidden = true
        if (nativeCheckoutButton) nativeCheckoutButton.hidden = true
        if (protectionBlock) protectionBlock.hidden = true
        if (withoutProtectionButton) withoutProtectionButton.hidden = true
        if (widgetHost) widgetHost.hidden = true

        let checkoutLink = drawer.querySelector('[data-petes-subscription-checkout]')
        if (!checkoutLink) {
          checkoutLink = document.createElement('a')
          checkoutLink.href = '/checkout'
          checkoutLink.className = 'petes-subscription-checkout'
          checkoutLink.dataset.petesSubscriptionCheckout = 'true'
          checkoutLink.textContent = this.labels.checkout

        }

        // Checkout belongs beside the native form, independent of footer copy.
        // Reconcile on every render so a replaced form cannot orphan the link.
        const checkoutForm = nativeCheckoutButton && nativeCheckoutButton.closest('form')
        if (checkoutForm && checkoutForm.parentElement) {
          if (checkoutForm.nextElementSibling !== checkoutLink) {
            checkoutForm.insertAdjacentElement('afterend', checkoutLink)
          }
        } else {
          checkoutLink.remove()
        }
      } else {
        if (paidProtectionButton) paidProtectionButton.hidden = false
        if (nativeCheckoutButton) nativeCheckoutButton.hidden = false
        if (protectionBlock) protectionBlock.hidden = false
        if (withoutProtectionButton) withoutProtectionButton.hidden = false
        if (widgetHost) widgetHost.hidden = false
        const checkoutLink = drawer.querySelector('[data-petes-subscription-checkout]')
        if (checkoutLink) checkoutLink.remove()
      }
    }

    render() {
      const drawer = document.querySelector('#cart-drawer [role="dialog"]')
      if (!drawer) return
      this.hideUpsells(drawer)
      this.hideManagedRows(drawer)
      this.syncBundleTitles(drawer)
      this.syncVisibleItemCount(drawer)
      this.syncShippingMessage(drawer)
      this.syncProtectionCheckout(drawer)
      let panel = drawer.querySelector('[data-petes-subscription-benefit-pills]')
      if (!this.tier) {
        drawer.querySelectorAll('.petes-subscription-main-row').forEach((row) => row.classList.remove('petes-subscription-main-row'))
        if (panel) panel.remove()
        return
      }
      if (!panel) {
        panel = document.createElement('li')
        panel.className = 'petes-subscription-benefits'
        panel.dataset.petesSubscriptionBenefitPills = 'true'
        panel.setAttribute('role', 'group')
        panel.setAttribute('aria-label', this.labels.heading)
      }
      const list = drawer.querySelector('ul')
      const normalize = (text) => String(text || '').trim().replace(/\s+/g, ' ').toLowerCase()
      const subscriptions = (this.cart?.items || [])
        .filter((item) => this.itemPackSize(item) >= this.tier)
        .sort((a, b) => this.itemPackSize(b) - this.itemPackSize(a))
      const rows = list ? Array.from(list.children).filter((row) => !row.hidden) : []
      let mainRow = null
      for (const item of subscriptions) {
        const planName = normalize(item.selling_plan_allocation?.selling_plan?.name)
        if (!planName) continue
        mainRow = rows.find((row) => {
          const link = row.querySelector('a[href*="/products/"]')
          if (!link) return false
          const path = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/$/, '')
          if (!path.endsWith('/products/' + item.handle)) return false
          const hasPlan = Array.from(link.querySelectorAll('span')).some((span) => normalize(span.textContent) === planName)
          const variant = normalize(item.variant_title)
          const title = normalize(link.querySelector('span.block.font-bold.uppercase')?.textContent)
          return hasPlan && (!variant || variant === 'default title' || title.includes(variant))
        })
        if (mainRow) break
      }
      drawer.querySelectorAll('.petes-subscription-main-row').forEach((row) => {
        if (row !== mainRow) row.classList.remove('petes-subscription-main-row')
      })
      if (mainRow) mainRow.classList.add('petes-subscription-main-row')
      if (mainRow && panel.previousElementSibling !== mainRow) mainRow.insertAdjacentElement('afterend', panel)
      else if (!mainRow) { panel.remove(); return }
      const checkIcon = '<svg class="petes-subscription-benefits__check" viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16.5459 8.95406C16.6508 9.05858 16.734 9.18277 16.7908 9.31952C16.8476 9.45626 16.8768 9.60287 16.8768 9.75094C16.8768 9.899 16.8476 10.0456 16.7908 10.1824C16.734 10.3191 16.6508 10.4433 16.5459 10.5478L11.2959 15.7978C11.1914 15.9027 11.0672 15.9859 10.9305 16.0427C10.7937 16.0995 10.6471 16.1287 10.4991 16.1287C10.351 16.1287 10.2044 16.0995 10.0676 16.0427C9.9309 15.9859 9.8067 15.9027 9.70219 15.7978L7.45219 13.5478C7.34754 13.4432 7.26453 13.3189 7.2079 13.1822C7.15126 13.0455 7.12211 12.8989 7.12211 12.7509C7.12211 12.6029 7.15126 12.4564 7.2079 12.3197C7.26453 12.1829 7.34754 12.0587 7.45219 11.9541C7.55683 11.8494 7.68107 11.7664 7.8178 11.7098C7.95452 11.6531 8.10107 11.624 8.24906 11.624C8.39706 11.624 8.5436 11.6531 8.68033 11.7098C8.81706 11.7664 8.94129 11.8494 9.04594 11.9541L10.5 13.4062L14.9541 8.95125C15.0587 8.84684 15.183 8.76408 15.3196 8.7077C15.4563 8.65133 15.6027 8.62245 15.7506 8.62271C15.8984 8.62297 16.0448 8.65237 16.1812 8.70922C16.3177 8.76608 16.4416 8.84928 16.5459 8.95406ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06065 21.5398 6.25655 20.5755 4.84054 19.1595C3.42454 17.7435 2.46022 15.9393 2.06955 13.9753C1.67887 12.0112 1.87938 9.97543 2.64572 8.12533C3.41206 6.27523 4.7098 4.69392 6.37485 3.58137C8.0399 2.46882 9.99746 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93606 4.58017 7.53287 5.3302 6.43153 6.43153C5.3302 7.53287 4.58017 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62488 18.5478C8.91992 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12Z" fill="currentColor"/></svg>'
      const pills = this.benefitLabels()
        .map((label) => `<span class="petes-subscription-benefits__pill">${checkIcon}<span>${this.escape(label)}</span></span>`)
        .join('')
      const signature = String(this.tier) + ':' + pills
      if (panel.dataset.signature === signature) return
      panel.dataset.signature = signature
      panel.innerHTML = `<strong class="petes-subscription-benefits__heading">${this.escape(this.labels.heading)}</strong><div class="petes-subscription-benefits__pills">${pills}</div>`
    }

    escape(value) {
      const node = document.createElement('span')
      node.textContent = value
      return node.innerHTML
    }
  }

  if (!customElements.get('petes-subscription-benefits')) {
    customElements.define('petes-subscription-benefits', PetesSubscriptionBenefits)
  }
  } catch(e) { console.error(e); }
})();

})();
